import { Size } from '~/types/ThemeTypes'
import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { MultiStyleType } from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

const callHeaderParts = [
  'container',
  'name',
  'number',
  'status',
  'time',
  'dtmf',
] as const

const helpers = createMultiStyleConfigHelpers(callHeaderParts)

export const CallHeaderStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: 'fit-content',
      paddingX: '32px',
      paddingY: '10px',
    },
    name: {
      color: 'fg.default',
      marginBottom: '5px',
      textAlign: 'center',
    },
    number: {
      fontWeight: '400',
      color: 'fg.default',
    },
    status: {
      ml: '.5rem',
      fontWeight: '400',
      color: 'fg.default',
    },
    time: {
      ml: '.5rem',
      minWidth: '2.75em',
      fontWeight: '400',
      color: 'fg.default',
    },
    dtmf: {
      fontWeight: '700',
      color: 'fg.default',
    },
  },
  sizes: {
    [Size.sm]: {
      container: {},
      name: {
        fontSize: '36px',
        letterSpacing: '-0.36px',
        fontWeight: '800',
        lineHeight: '36px',
      },
      number: {
        fontsize: '16px',
      },
      status: {
        fontSize: '16px',
      },
      time: {
        fontSize: '16px',
      },
      dtmf: {
        fontSize: '14px',
      },
    },
    [Size.md]: {
      container: {},
      name: {
        fontSize: '40px',
        letterSpacing: '-0.40px',
        fontWeight: '800',
        lineHeight: '40px',
      },
      number: {
        fontSize: '20px',
      },
      status: {
        fontSize: '20px',
      },
      time: {
        fontSize: '20px',
      },
      dtmf: {
        fontSize: '18px',
      },
    },
    [Size.lg]: {
      container: {},
      name: {
        fontSize: '56px',
        letterSpacing: '-0.56px',
        fontWeight: '700',
        height: '62px',
        lineHeight: '56px',
      },
      number: {
        fontSize: '24px',
      },
      status: {
        fontSize: '24px',
      },
      time: {
        fontSize: '24px',
      },
      dtmf: {
        fontSize: '22px',
      },
    },
  },
  defaultProps: {},
})

export const useCallHeaderStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(CallHeaderStyle, props) as MultiStyleType<
    typeof callHeaderParts
  >
}
